module.exports = __webpack_public_path__ + "static/sixth-step-apartados-abe92c34789004c04fee7fc97dbb2ea5.svg";